import type { Inventory } from '@features/in-stores/types/inventory.types';

const baseInventoryData = [
  {
    id: 'inv_001',
    transactionRef: 'txn_inv_001_ref',
    model: 'Terminal Pro X1',
    serialNumber: 'TPX1-2024-001',
    store: 'Downtown Store',
    order: 'ORD-2024-001',
    ordered: '2024-01-15T10:00:00Z',
    fulfilled: '2024-01-20T14:30:00Z',
    moved: '2024-02-10T09:15:00Z',
  },
  {
    id: 'inv_002',
    transactionRef: 'txn_inv_002_ref',
    model: 'Terminal Lite V2',
    serialNumber: 'TLV2-2024-002',
    store: 'Mall Location',
    order: 'ORD-2024-002',
    ordered: '2024-01-16T09:30:00Z',
    fulfilled: '2024-01-22T11:15:00Z',
    moved: '2024-02-08T14:20:00Z',
  },
  {
    id: 'inv_003',
    transactionRef: 'txn_inv_003_ref',
    model: 'Terminal Pro X1',
    serialNumber: 'TPX1-2024-003',
    store: 'Airport Branch',
    order: 'ORD-2024-003',
    ordered: '2024-01-18T14:20:00Z',
    fulfilled: '2024-01-24T10:45:00Z',
    moved: '2024-02-12T08:30:00Z',
  },
  {
    id: 'inv_004',
    transactionRef: 'txn_inv_004_ref',
    model: 'Terminal Compact',
    serialNumber: 'TC-2024-004',
    store: 'Food Court',
    order: 'ORD-2024-004',
    ordered: '2024-01-20T11:00:00Z',
    fulfilled: '2024-01-26T15:20:00Z',
    moved: '2024-02-09T16:45:00Z',
  },
  {
    id: 'inv_005',
    transactionRef: 'txn_inv_005_ref',
    model: 'Terminal Pro X2',
    serialNumber: 'TPX2-2024-005',
    store: 'Westside Plaza',
    order: 'ORD-2024-005',
    ordered: '2024-01-22T08:15:00Z',
    fulfilled: '2024-01-28T13:45:00Z',
    moved: '2024-02-11T10:20:00Z',
  },
  {
    id: 'inv_006',
    transactionRef: 'txn_inv_006_ref',
    model: 'Terminal Mobile',
    serialNumber: 'TM-2024-006',
    store: 'Coffee Shop Central',
    order: 'ORD-2024-006',
    ordered: '2024-01-25T16:30:00Z',
    fulfilled: '2024-01-30T09:00:00Z',
    moved: '2024-02-13T11:30:00Z',
  },
  {
    id: 'inv_007',
    transactionRef: 'txn_inv_007_ref',
    model: 'Terminal Lite V2',
    serialNumber: 'TLV2-2024-007',
    store: 'University Bookstore',
    order: 'ORD-2024-007',
    ordered: '2024-01-28T12:45:00Z',
    fulfilled: '2024-02-02T11:30:00Z',
    moved: '2024-02-07T15:00:00Z',
  },
  {
    id: 'inv_008',
    transactionRef: 'txn_inv_008_ref',
    model: 'Terminal Pro X1',
    serialNumber: 'TPX1-2024-008',
    store: 'Sports Arena',
    order: 'ORD-2024-008',
    ordered: '2024-01-30T10:20:00Z',
    fulfilled: '2024-02-04T16:10:00Z',
    moved: '2024-02-14T12:00:00Z',
  },
  {
    id: 'inv_009',
    transactionRef: 'txn_inv_009_ref',
    model: 'Terminal Compact',
    serialNumber: 'TC-2024-009',
    store: 'Hotel Lobby',
    order: 'ORD-2024-009',
    ordered: '2024-02-01T14:00:00Z',
    fulfilled: '2024-02-05T12:15:00Z',
    moved: '2024-02-10T17:20:00Z',
  },
  {
    id: 'inv_010',
    transactionRef: 'txn_inv_010_ref',
    model: 'Terminal Pro X2',
    serialNumber: 'TPX2-2024-010',
    store: 'Marina District',
    order: 'ORD-2024-010',
    ordered: '2024-02-03T09:45:00Z',
    fulfilled: '2024-02-07T14:30:00Z',
    moved: '2024-02-12T19:45:00Z',
  },
  {
    id: 'inv_011',
    transactionRef: 'txn_inv_011_ref',
    model: 'Terminal Mobile',
    serialNumber: 'TM-2024-011',
    store: 'Farmers Market',
    order: 'ORD-2024-011',
    ordered: '2024-02-05T11:30:00Z',
    fulfilled: '2024-02-08T08:45:00Z',
    moved: '2024-02-09T13:20:00Z',
  },
  {
    id: 'inv_012',
    transactionRef: 'txn_inv_012_ref',
    model: 'Terminal Lite V2',
    serialNumber: 'TLV2-2024-012',
    store: 'Tech Conference Center',
    order: 'ORD-2024-012',
    ordered: '2024-02-06T15:20:00Z',
    fulfilled: '2024-02-09T10:15:00Z',
    moved: '2024-02-13T16:00:00Z',
  },
  {
    id: 'inv_013',
    transactionRef: 'txn_inv_013_ref',
    model: 'Terminal Pro X1',
    serialNumber: 'TPX1-2024-013',
    store: 'Shopping Center East',
    order: 'ORD-2024-013',
    ordered: '2024-02-08T13:10:00Z',
    fulfilled: '2024-02-10T15:30:00Z',
    moved: '2024-02-14T18:15:00Z',
  },
  {
    id: 'inv_014',
    transactionRef: 'txn_inv_014_ref',
    model: 'Terminal Compact',
    serialNumber: 'TC-2024-014',
    store: 'Museum Gift Shop',
    order: 'ORD-2024-014',
    ordered: '2024-02-10T10:45:00Z',
    fulfilled: '2024-02-12T12:20:00Z',
  },
  {
    id: 'inv_015',
    transactionRef: 'txn_inv_015_ref',
    model: 'Terminal Pro X2',
    serialNumber: 'TPX2-2024-015',
    store: 'Transit Station',
    order: 'ORD-2024-015',
    ordered: '2024-02-12T08:00:00Z',
    fulfilled: '2024-02-14T11:45:00Z',
    moved: '2024-02-15T14:20:00Z',
  },
  {
    id: 'inv_016',
    transactionRef: 'txn_inv_016_ref',
    model: 'Terminal Mobile',
    serialNumber: 'TM-2024-016',
    store: 'Beach Resort',
    order: 'ORD-2024-016',
    ordered: '2024-02-13T09:30:00Z',
    fulfilled: '2024-02-15T13:15:00Z',
    moved: '2024-02-16T10:00:00Z',
  },
  {
    id: 'inv_017',
    transactionRef: 'txn_inv_017_ref',
    model: 'Terminal Lite V2',
    serialNumber: 'TLV2-2024-017',
    store: 'Convention Center',
    order: 'ORD-2024-017',
    ordered: '2024-02-14T11:00:00Z',
    fulfilled: '2024-02-16T14:45:00Z',
  },
  {
    id: 'inv_018',
    transactionRef: 'txn_inv_018_ref',
    model: 'Terminal Pro X1',
    serialNumber: 'TPX1-2024-018',
    store: 'City Hall Plaza',
    order: 'ORD-2024-018',
    ordered: '2024-02-15T10:15:00Z',
    fulfilled: '2024-02-17T12:30:00Z',
    moved: '2024-02-18T09:00:00Z',
  },
  {
    id: 'inv_019',
    transactionRef: 'txn_inv_019_ref',
    model: 'Terminal Compact',
    serialNumber: 'TC-2024-019',
    store: 'Art Gallery',
    order: 'ORD-2024-019',
    ordered: '2024-02-16T14:30:00Z',
    fulfilled: '2024-02-18T16:00:00Z',
    moved: '2024-02-19T11:15:00Z',
  },
  {
    id: 'inv_020',
    transactionRef: 'txn_inv_020_ref',
    model: 'Terminal Pro X2',
    serialNumber: 'TPX2-2024-020',
    store: 'Stadium Concourse',
    order: 'ORD-2024-020',
    ordered: '2024-02-17T08:45:00Z',
    fulfilled: '2024-02-19T10:20:00Z',
    moved: '2024-02-20T15:30:00Z',
  },
  {
    id: 'inv_021',
    transactionRef: 'txn_inv_021_ref',
    model: 'Terminal Lite V2',
    serialNumber: 'TLV2-2024-021',
    store: 'Riverside Mall',
    order: 'ORD-2024-021',
    ordered: '2024-02-18T10:00:00Z',
    fulfilled: '2024-02-20T14:15:00Z',
    moved: '2024-02-21T09:30:00Z',
  },
  {
    id: 'inv_022',
    transactionRef: 'txn_inv_022_ref',
    model: 'Terminal Pro X1',
    serialNumber: 'TPX1-2024-022',
    store: 'Central Station',
    order: 'ORD-2024-022',
    ordered: '2024-02-19T11:30:00Z',
    fulfilled: '2024-02-21T15:45:00Z',
    moved: '2024-02-22T10:00:00Z',
  },
  {
    id: 'inv_023',
    transactionRef: 'txn_inv_023_ref',
    model: 'Terminal Compact',
    serialNumber: 'TC-2024-023',
    store: 'Fashion District',
    order: 'ORD-2024-023',
    ordered: '2024-02-20T09:15:00Z',
    fulfilled: '2024-02-22T13:30:00Z',
  },
  {
    id: 'inv_024',
    transactionRef: 'txn_inv_024_ref',
    model: 'Terminal Mobile',
    serialNumber: 'TM-2024-024',
    store: 'Park Avenue',
    order: 'ORD-2024-024',
    ordered: '2024-02-21T14:00:00Z',
    fulfilled: '2024-02-23T16:20:00Z',
    moved: '2024-02-24T11:45:00Z',
  },
  {
    id: 'inv_025',
    transactionRef: 'txn_inv_025_ref',
    model: 'Terminal Pro X2',
    serialNumber: 'TPX2-2024-025',
    store: 'Tech Hub',
    order: 'ORD-2024-025',
    ordered: '2024-02-22T08:30:00Z',
    fulfilled: '2024-02-24T12:00:00Z',
    moved: '2024-02-25T14:30:00Z',
  },
  {
    id: 'inv_026',
    transactionRef: 'txn_inv_026_ref',
    model: 'Terminal Lite V2',
    serialNumber: 'TLV2-2024-026',
    store: 'Garden Center',
    order: 'ORD-2024-026',
    ordered: '2024-02-23T10:45:00Z',
    fulfilled: '2024-02-25T14:15:00Z',
  },
  {
    id: 'inv_027',
    transactionRef: 'txn_inv_027_ref',
    model: 'Terminal Pro X1',
    serialNumber: 'TPX1-2024-027',
    store: 'Lakeside Plaza',
    order: 'ORD-2024-027',
    ordered: '2024-02-24T12:00:00Z',
    fulfilled: '2024-02-26T15:30:00Z',
    moved: '2024-02-27T09:00:00Z',
  },
  {
    id: 'inv_028',
    transactionRef: 'txn_inv_028_ref',
    model: 'Terminal Compact',
    serialNumber: 'TC-2024-028',
    store: 'Medical Center',
    order: 'ORD-2024-028',
    ordered: '2024-02-25T13:15:00Z',
    fulfilled: '2024-02-27T16:45:00Z',
    moved: '2024-02-28T10:15:00Z',
  },
  {
    id: 'inv_029',
    transactionRef: 'txn_inv_029_ref',
    model: 'Terminal Mobile',
    serialNumber: 'TM-2024-029',
    store: 'Cinema Complex',
    order: 'ORD-2024-029',
    ordered: '2024-02-26T09:30:00Z',
    fulfilled: '2024-02-28T13:00:00Z',
  },
  {
    id: 'inv_030',
    transactionRef: 'txn_inv_030_ref',
    model: 'Terminal Pro X2',
    serialNumber: 'TPX2-2024-030',
    store: 'Business Park',
    order: 'ORD-2024-030',
    ordered: '2024-02-27T11:00:00Z',
    fulfilled: '2024-03-01T14:30:00Z',
    moved: '2024-03-02T16:00:00Z',
  },
  {
    id: 'inv_031',
    transactionRef: 'txn_inv_031_ref',
    model: 'Terminal Lite V2',
    serialNumber: 'TLV2-2024-031',
    store: 'Harbor Front',
    order: 'ORD-2024-031',
    ordered: '2024-02-28T14:45:00Z',
    fulfilled: '2024-03-02T17:15:00Z',
    moved: '2024-03-03T11:30:00Z',
  },
  {
    id: 'inv_032',
    transactionRef: 'txn_inv_032_ref',
    model: 'Terminal Pro X1',
    serialNumber: 'TPX1-2024-032',
    store: 'Retail Center',
    order: 'ORD-2024-032',
    ordered: '2024-03-01T08:00:00Z',
    fulfilled: '2024-03-03T11:30:00Z',
  },
  {
    id: 'inv_033',
    transactionRef: 'txn_inv_033_ref',
    model: 'Terminal Compact',
    serialNumber: 'TC-2024-033',
    store: 'Town Square',
    order: 'ORD-2024-033',
    ordered: '2024-03-02T10:15:00Z',
    fulfilled: '2024-03-04T13:45:00Z',
    moved: '2024-03-05T08:00:00Z',
  },
  {
    id: 'inv_034',
    transactionRef: 'txn_inv_034_ref',
    model: 'Terminal Mobile',
    serialNumber: 'TM-2024-034',
    store: 'Event Center',
    order: 'ORD-2024-034',
    ordered: '2024-03-03T12:30:00Z',
    fulfilled: '2024-03-05T15:00:00Z',
    moved: '2024-03-06T09:15:00Z',
  },
  {
    id: 'inv_035',
    transactionRef: 'txn_inv_035_ref',
    model: 'Terminal Pro X2',
    serialNumber: 'TPX2-2024-035',
    store: 'Outlet Mall',
    order: 'ORD-2024-035',
    ordered: '2024-03-04T09:00:00Z',
    fulfilled: '2024-03-06T12:30:00Z',
  },
  {
    id: 'inv_036',
    transactionRef: 'txn_inv_036_ref',
    model: 'Terminal Lite V2',
    serialNumber: 'TLV2-2024-036',
    store: 'Community Center',
    order: 'ORD-2024-036',
    ordered: '2024-03-05T11:15:00Z',
    fulfilled: '2024-03-07T14:45:00Z',
    moved: '2024-03-08T10:30:00Z',
  },
  {
    id: 'inv_037',
    transactionRef: 'txn_inv_037_ref',
    model: 'Terminal Pro X1',
    serialNumber: 'TPX1-2024-037',
    store: 'Metro Station',
    order: 'ORD-2024-037',
    ordered: '2024-03-06T13:30:00Z',
    fulfilled: '2024-03-08T16:00:00Z',
    moved: '2024-03-09T11:45:00Z',
  },
  {
    id: 'inv_038',
    transactionRef: 'txn_inv_038_ref',
    model: 'Terminal Compact',
    serialNumber: 'TC-2024-038',
    store: 'Fitness Center',
    order: 'ORD-2024-038',
    ordered: '2024-03-07T08:45:00Z',
    fulfilled: '2024-03-09T11:15:00Z',
  },
  {
    id: 'inv_039',
    transactionRef: 'txn_inv_039_ref',
    model: 'Terminal Mobile',
    serialNumber: 'TM-2024-039',
    store: 'Library Plaza',
    order: 'ORD-2024-039',
    ordered: '2024-03-08T10:00:00Z',
    fulfilled: '2024-03-10T13:30:00Z',
    moved: '2024-03-11T08:15:00Z',
  },
  {
    id: 'inv_040',
    transactionRef: 'txn_inv_040_ref',
    model: 'Terminal Pro X2',
    serialNumber: 'TPX2-2024-040',
    store: 'Wholesale District',
    order: 'ORD-2024-040',
    ordered: '2024-03-09T12:15:00Z',
    fulfilled: '2024-03-11T15:45:00Z',
    moved: '2024-03-12T09:30:00Z',
  },
  {
    id: 'inv_041',
    transactionRef: 'txn_inv_041_ref',
    model: 'Terminal Lite V2',
    serialNumber: 'TLV2-2024-041',
    store: 'North Plaza',
    order: 'ORD-2024-041',
    ordered: '2024-03-10T14:30:00Z',
    fulfilled: '2024-03-12T17:00:00Z',
  },
  {
    id: 'inv_042',
    transactionRef: 'txn_inv_042_ref',
    model: 'Terminal Pro X1',
    serialNumber: 'TPX1-2024-042',
    store: 'South Market',
    order: 'ORD-2024-042',
    ordered: '2024-03-11T09:45:00Z',
    fulfilled: '2024-03-13T12:15:00Z',
    moved: '2024-03-14T14:00:00Z',
  },
  {
    id: 'inv_043',
    transactionRef: 'txn_inv_043_ref',
    model: 'Terminal Compact',
    serialNumber: 'TC-2024-043',
    store: 'East End',
    order: 'ORD-2024-043',
    ordered: '2024-03-12T11:00:00Z',
    fulfilled: '2024-03-14T14:30:00Z',
    moved: '2024-03-15T08:45:00Z',
  },
  {
    id: 'inv_044',
    transactionRef: 'txn_inv_044_ref',
    model: 'Terminal Mobile',
    serialNumber: 'TM-2024-044',
    store: 'West Side',
    order: 'ORD-2024-044',
    ordered: '2024-03-13T13:15:00Z',
    fulfilled: '2024-03-15T16:45:00Z',
  },
  {
    id: 'inv_045',
    transactionRef: 'txn_inv_045_ref',
    model: 'Terminal Pro X2',
    serialNumber: 'TPX2-2024-045',
    store: 'Financial District',
    order: 'ORD-2024-045',
    ordered: '2024-03-14T08:30:00Z',
    fulfilled: '2024-03-16T11:00:00Z',
    moved: '2024-03-17T13:30:00Z',
  },
  {
    id: 'inv_046',
    transactionRef: 'txn_inv_046_ref',
    model: 'Terminal Lite V2',
    serialNumber: 'TLV2-2024-046',
    store: 'Historic Quarter',
    order: 'ORD-2024-046',
    ordered: '2024-03-15T10:45:00Z',
    fulfilled: '2024-03-17T13:15:00Z',
    moved: '2024-03-18T15:00:00Z',
  },
  {
    id: 'inv_047',
    transactionRef: 'txn_inv_047_ref',
    model: 'Terminal Pro X1',
    serialNumber: 'TPX1-2024-047',
    store: 'Innovation Park',
    order: 'ORD-2024-047',
    ordered: '2024-03-16T12:00:00Z',
    fulfilled: '2024-03-18T15:30:00Z',
  },
  {
    id: 'inv_048',
    transactionRef: 'txn_inv_048_ref',
    model: 'Terminal Compact',
    serialNumber: 'TC-2024-048',
    store: 'Sunset Boulevard',
    order: 'ORD-2024-048',
    ordered: '2024-03-17T14:15:00Z',
    fulfilled: '2024-03-19T17:45:00Z',
    moved: '2024-03-20T09:00:00Z',
  },
  {
    id: 'inv_049',
    transactionRef: 'txn_inv_049_ref',
    model: 'Terminal Mobile',
    serialNumber: 'TM-2024-049',
    store: 'Sunrise Mall',
    order: 'ORD-2024-049',
    ordered: '2024-03-18T09:30:00Z',
    fulfilled: '2024-03-20T12:00:00Z',
    moved: '2024-03-21T10:15:00Z',
  },
  {
    id: 'inv_050',
    transactionRef: 'txn_inv_050_ref',
    model: 'Terminal Pro X2',
    serialNumber: 'TPX2-2024-050',
    store: 'Valley Shopping Center',
    order: 'ORD-2024-050',
    ordered: '2024-03-19T11:45:00Z',
    fulfilled: '2024-03-21T14:15:00Z',
    moved: '2024-03-22T16:30:00Z',
  }
];

// Add status field to all inventory items since the type requires it
export const mockInventoryData: Inventory[] = baseInventoryData.map(item => ({
  ...item,
  status: 'active' // Simple constant status since inventory doesn't use status filtering
}));